import axios from 'axios';

const apiBaseURL = window.APP_CONFIG.API_BASE_URL;

//创建Axios 实例
const apiClient = axios.create({
    baseURL: `${apiBaseURL}/api`,
    timeout: 5000,
});

//发送get请求，获取文章列表信息
export const fetchPosts=(currentPage = 1, pageSize = 10, language = 'en') =>{
    return apiClient.get('/posts', {
        params: { currentPage, pageSize, lang: language },
    });
};

//发送get请求，获取文章详情
export const fetchDetailPost=(id, language) => {
    return apiClient.get(`/post/${id}`, {
        params: language ? { lang: language } : undefined,
    });
}
